// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--JdWD4","subtitle":"_93444fe79c--subtitle--iGb0_"};